import './css/App.css';
import { HashRouter, Routes, Route } from "react-router-dom";
import Header from './components/Header'
import Footer from './components/Footer'
import AboutMe from './components/AboutMe';
import Portfolio from './components/Portfolio';
import Contact from './components/Contact';
import Resume from './components/Resume';

function App() {

  return (
    <>
    <Header />
    <main>
    <HashRouter basename='/'>
        <Routes>
            <Route path="/" element={<AboutMe />} />
            <Route path="/portfolio" element={<Portfolio />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/resume" element={<Resume />} />
        </Routes>
    </HashRouter>
    </main>
    <Footer />
    </>
  );
}
export default App;
